export default __webpack_public_path__ + "static/brand-image_2x-798e76d31bff41b45d6a17a44f185cf2.jpg";